import {PlainLink} from 'core/components/link'
import {IFormFields, Password, resetFormFactory} from 'study_reviewer/components/passwordReset'
import {routeProps} from 'core/utils/react-router-helpers'
import * as React from 'react'
import {connect, Dispatch} from 'react-redux'
import {Redirect, RouteComponentProps, withRouter} from 'react-router'
import Card from 'study_reviewer/components/Card'
import * as routes from 'study_reviewer/routes'
import {IState, passwordResetRequest} from 'study_reviewer/store'
import * as styles from './LoginPage.css'

interface IStateProps {
  isLoggedIn: boolean
}
interface IDispatchProps {
}
interface IOwnProps extends RouteComponentProps<void> {}
interface IProps extends IStateProps, IDispatchProps, IOwnProps {}

const PASSWORD_FORM_NAME = 'forgotPassword'
const onSubmit = (data: IFormFields, dispatch: Dispatch<void>) => {
  dispatch(passwordResetRequest(data, PASSWORD_FORM_NAME))
}
const PasswordReset = resetFormFactory({formName: PASSWORD_FORM_NAME, onSubmit})

class RegisterPageView extends React.Component<IProps, {}> {
  public render() {
    const {isLoggedIn} = this.props
    if (isLoggedIn) return this.redirectToReferrer()

    return (
      <div className={styles.page}>
        <Card>
          <Password
            {...routeProps<IProps, void>(this.props)}
            renderForm={() => <PasswordReset theme={{error: styles.error}} />}
            theme={{graphic: styles.graphic, lettering: styles.lettering}}
          />
        </Card>
        <Card>
          <PlainLink className={styles.link} to={routes.loginRoute()}><u>Return to Login</u></PlainLink>
        </Card>
      </div>
    )
  }

  private redirectToReferrer() {
    const from = this.props.location.state && this.props.location.state.from
    if (!from || from.pathname === routes.loginRoute() || from.pathname === routes.logoutRoute()) {
      return <Redirect to={routes.loginRoute()} />
    }
    return <Redirect to={from} />
  }
}

const mapStateToProps = (state: IState): IStateProps => ({
  isLoggedIn: !!state.login.token,
})

export default withRouter(
  connect<IStateProps, IDispatchProps, IOwnProps, IState>(mapStateToProps)(RegisterPageView),
)



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_reviewer/src/pages/ForgotPasswordPage.tsx